export type DefinitionReadiness = {
  ready: boolean;
  missing: string[];
  counts: {
    goals: number;
    features: number;
    inScope: number;
  };
};

export function getDefinitionReadiness(definition: any): DefinitionReadiness {
  const def = (definition && typeof definition === 'object') ? definition : {};

  const name = String(def.name ?? '').trim();
  const description = String(def.description ?? '').trim();
  const goals = Array.isArray(def.goals) ? def.goals.length : 0;
  const features = Array.isArray(def.features) ? def.features.length : 0;
  const inScope = Array.isArray(def.inScope) ? def.inScope.length : 0;

  const missing: string[] = [];

  if (!name) missing.push('Project name is required');
  if (!description) missing.push('Project description is required');
  if (goals < 1) missing.push('Add at least 1 goal');
  if (features < 5) missing.push('Add at least 5 features');
  if (inScope < 3) missing.push('Add at least 3 in-scope items');

  return {
    ready: missing.length === 0,
    missing,
    counts: { goals, features, inScope },
  };
}

